import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=254eeaef&scoped=true&lang=pug"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=254eeaef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254eeaef",
  null
  
)

export default component.exports